(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
window.updateRoleBasedElements = function () {
  var cookie = document.cookie;
  var ca = cookie.split(';');
  var name = "FrnHOST=";
  var cook = "";
  for (var i = 0; i < ca.length; i++) {
    var c = decodeURIComponent(ca[i]);
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      cook = c.substring(name.length, c.length);
    }
  }
  if (cook !== "") {
    cook = cook.replace('state=', '');
    window.cookieStateValues = JSON.parse(cook);
  }
  if (window.cookieStateValues !== undefined && window.cookieStateValues.roles !== undefined) {
    var roles = JSON.parse(window.cookieStateValues.roles);
    $('.dynamic-link').each(function (i, ele) {
      $(ele).prop("href", "");
    });
    $('.dynamic-script').each(function (i, ele) {
      $(ele).prop("src", "");
    });
    $('.show-by-role').each(function (i, ele) {
      $(ele).hide();
    });
    roles.map(function (role) {
      $('i[data-role="' + role + '"]').each(function (i, s) {
        var scriptTemplate = $(s);
        var src = scriptTemplate.data('src');
        var script = document.createElement('script');
        script.src = src;
        console.log("appending", src);
        document.head.appendChild(script);
      });
      $('.show-by-role').each(function (i, ele) {
        var element = $(ele);
        var data = element.data('show-by-role');
        if (data !== undefined && data !== null) {
          var isArray = data instanceof Array;
          if (isArray) {
            data.map(function (forRole) {
              if (forRole === role) {
                element.show();
              }
            });
          } else {
            if (data === role) {
              element.show();
            }
          }
        }
      });
      if (role === "Guest") {
        $('a[data-guest-link]').each(function (i, link) {
          var linkBox = $(link);
          var url = linkBox.data('guest-link');
          $(link).prop('href', url);
        });
      }
      if (role === "Support" || role === "Client" || role === "FH") {
        $('a[data-user-link]').each(function (i, link) {
          var linkBox = $(link);
          var url = linkBox.data('user-link');
          $(link).prop('href', url);
        });
        if (role === "Support") {
          $('a[data-support-link]').each(function (i, link) {
            var linkBox = $(link);
            var url = linkBox.data('support-link');
            $(link).prop('href', url);
          });
        }
        if (role === "Client") {
          $('a[data-client-link]').each(function (i, link) {
            var linkBox = $(link);
            var url = linkBox.data('client-link');
            $(link).prop('href', url);
          });
        }
        if (role === "FH") {
          $('a[data-fh-link]').each(function (i, link) {
            var linkBox = $(link);
            var url = linkBox.data('fh-link');
            $(link).prop('href', url);
          });
        }
      }
    });
  } else {}
  var guestSlots = document.getElementsByClassName('is-guest');
  var authSlots = document.getElementsByClassName('is-authenticated');
  Array.prototype.filter.call(guestSlots, function (guestSlot) {
    guestSlot.style.setProperty("display", "none", "important");
  });
  Array.prototype.filter.call(authSlots, function (authSlot) {
    authSlot.style.setProperty("display", "none", "important");
  });
  if (window.cookieStateValues !== undefined && window.cookieStateValues.logged !== undefined && window.cookieStateValues.logged === "1") {
    Array.prototype.filter.call(authSlots, function (authSlot) {
      var displayAs = authSlot.dataset.display;
      if (displayAs === undefined) {
        authSlot.style.display = "";
      } else {
        authSlot.style.display = displayAs;
      }
    });
  } else if (window.cookieStateValues !== undefined && window.cookieStateValues.logged !== undefined && window.cookieStateValues.logged === "0" || window.cookieStateValues === undefined || window.cookieStateValues.logged !== undefined) {
    Array.prototype.filter.call(guestSlots, function (guestSlot) {
      var displayAs = guestSlot.dataset.display;
      if (displayAs === undefined) {
        guestSlot.style.display = "";
      } else {
        guestSlot.style.display = displayAs;
      }
    });
  }
};
window.updateRoleBasedElements();
$(function () {
  $("[data-action=localtime]").each(function (i, ele) {
    var offset = parseInt($(ele).data('offset'));
    var utcTime = $(ele).data('utctime');
    var date = new Date(utcTime);
    var timezoneOffset = -date.getTimezoneOffset();
    if (!isNaN(offset)) {
      offset -= timezoneOffset;
    } else {
      offset = 0;
    }
    var newDate = new Date(date.getTime() + offset * 60 * 1000);
    var dateString = newDate.toLocaleDateString(window.CURRENT_LANG, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    var timeString = newDate.toLocaleTimeString(window.CURRENT_LANG, {
      hour: '2-digit',
      minute: '2-digit'
    });
    var html = '<span style="white-space:nowrap">' + dateString + "," + '</span> <span style="white-space:nowrap">' + timeString + '</span>';
    $(ele).html(html);
  });
});
$(function () {
  var _replaceInText = function replaceInText(element, pattern, replacement) {
    var _iterator = _createForOfIteratorHelper(element.childNodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        switch (node.nodeType) {
          case Node.ELEMENT_NODE:
            _replaceInText(node, pattern, replacement);
            break;
          case Node.TEXT_NODE:
            node.textContent = node.textContent.split(pattern).join(replacement);
            break;
          case Node.DOCUMENT_NODE:
            _replaceInText(node, pattern, replacement);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  setTimeout(function () {
    var hash = window.location.hash;
    if (hash.startsWith("#swap")) {
      $.ajax({
        url: '/api/cms/replacement-strings',
        type: 'GET',
        data: {
          swapStr: hash.substr(1)
        },
        success: function success(res) {
          window.replaceStringList = res.list;
          for (var i = 0; i < res.list.length; i++) {
            _replaceInText(document.body, res.list[i].Item1, res.list[i].Item2);
          }
        }
      });
    }
  }, 100);

  // update page links for cached page

  var basePath = window.location.pathname;
  if (basePath.includes("/" + window.CURRENT_LANG)) {
    basePath = basePath.replace("/" + window.CURRENT_LANG, "");
  }
  if (!basePath.startsWith("/")) {
    basePath += "/";
  }
  var baseUrl = basePath;
  if (location.search) baseUrl += location.search;
  var hreflangs = $("link[hreflang]");
  for (var i = 0; i < hreflangs.length; i++) {
    if (hreflangs[i].hreflang == 'en') hreflangs[i].href = baseUrl;else hreflangs[i].href = '/' + hreflangs[i].hreflang + (baseUrl == '/' ? '' : baseUrl);
  }
  var langSelectors = $("#lang-select li a");
  for (var i = 0; i < langSelectors.length; i++) {
    var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];
    var newLink = baseUrl;
    if (langCode != 'en') newLink = '/' + langCode + (newLink == '/' ? '' : newLink);
    langSelectors[i].href = newLink;
    $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + newLink + "','" + langCode + "')");
  }

  // UpdateSchemaTemplate();
});
window.UpdateSchemaTemplate = function () {
  $('script[type="application/ld+json"][dynamic-schema]').remove();
  if (!window.schemaTemplate) return;
  var pageTitle = $("title").text();
  var desc = $("meta[name=description]").attr('content');
  var updateAt = $('input[name=dynamic-schema-last-update]').val();
  var updatedSchema = window.schemaTemplate.replaceAll("{{PageTitle}}", pageTitle).replaceAll("{{PageDescription}}", desc);
  if (!updateAt) {
    updatedSchema = updatedSchema.replaceAll('"dateModified":"{{UpdatedAt}}",', '');
  } else {
    updatedSchema = updatedSchema.replaceAll("{{UpdatedAt}}", updateAt);
  }
  if (updatedSchema.includes("{{UserRatingValue}}")) {
    var userRating = GetUserRating();
    var userReviewCount = GetUserReviewCount();
    if (!userRating || userRating < 1) userRating = 1;
    if (!userReviewCount) updatedSchema = '';
    updatedSchema = updatedSchema.replaceAll("\"{{UserRatingValue}}\"", userRating);
    updatedSchema = updatedSchema.replaceAll("\"{{ReviewCount}}\"", userReviewCount);
  }
  if (updatedSchema.includes("{{OverallRatingValue}}")) {
    var overallRating = GetOverallRating();
    if (!overallRating || overallRating < 1) overallRating = 1;
    updatedSchema = updatedSchema.replaceAll("\"{{OverallRatingValue}}\"", overallRating);
  }
  if (updatedSchema.includes("{{BrokerLogoUrl}}")) {
    var logoComponent = $(".broker-detail-page .broker-detail-top-pane .broker-image > img");
    if (logoComponent.length > 0) {
      updatedSchema = updatedSchema.replaceAll("{{BrokerLogoUrl}}", logoComponent[0].src);
    }
  }
  if (updatedSchema.includes("{{BrokerWebsitesUrl}}")) {
    var websites = $('input[name=dynamic-schema-broker-websites]').val();
    if (!websites) {
      updatedSchema = updatedSchema.replaceAll('"sameAs":"{{BrokerWebsitesUrl}}",', '');
    } else {
      var websiteList = websites.split(',');
      if (websiteList.length == 1) {
        updatedSchema = updatedSchema.replaceAll('{{BrokerWebsitesUrl}}', websiteList[0]);
      } else if (websiteList.length > 1) {
        updatedSchema = updatedSchema.replaceAll('"{{BrokerWebsitesUrl}}"', JSON.stringify(websiteList));
      }
    }
  }
  if (updatedSchema != '') {
    var script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.setAttribute("dynamic-schema", "");
    script.textContent = updatedSchema.replaceAll("\r", "").replaceAll("\n", "");
    document.head.appendChild(script);
  }
};

},{}]},{},[1]);
